import React from 'react'
import { Link } from '@inertiajs/react'
import UserLayout from '../../../Layouts/UserLayout'

export default function Index({ blog_posts = [] }) {
  return (
    <UserLayout>
      <div className="max-w-5xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Admin: Blog Posts</h1>
          <div className="flex gap-3">
            <Link href="/admin/blog_posts/bulk_generate" className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700">
              Bulk Generator
            </Link>
            <Link href="/admin/blog_posts/new" className="bg-emerald-600 text-white px-4 py-2 rounded hover:bg-emerald-700">
              New Post
            </Link>
          </div>
        </div>

        <div className="bg-white shadow rounded overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 text-left">
                <th className="p-4 border-b">Title</th>
                <th className="p-4 border-b">Slug</th>
                <th className="p-4 border-b">Status</th>
                <th className="p-4 border-b text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {blog_posts.map(post => (
                <tr key={post.id} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="p-4 font-medium">{post.title}</td>
                  <td className="p-4 text-sm text-gray-600">/blog/{post.slug}</td>
                  <td className="p-4">
                    {post.published ? (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200">
                        Published
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 border border-gray-200">
                        Draft
                      </span>
                    )}
                  </td>
                  <td className="p-4 text-right space-x-3">
                    <a
                      href={`/admin/blog_posts/${post.slug}/preview`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-gray-600 hover:text-gray-900 font-medium"
                    >
                      Preview
                    </a>
                    {post.published && (
                      <a
                        href={`/blog/${post.slug}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-emerald-700 hover:text-emerald-900 font-medium"
                      >
                        Public
                      </a>
                    )}
                    <Link href={`/admin/blog_posts/${post.slug}/edit`} className="text-indigo-600 hover:text-indigo-900 font-medium">
                      Edit
                    </Link>
                    <Link
                      href={`/admin/blog_posts/${post.slug}`}
                      method="delete"
                      as="button"
                      className="text-red-600 hover:text-red-900 font-medium"
                      onClick={e => { if (!confirm('Are you sure?')) e.preventDefault() }}
                    >
                      Delete
                    </Link>
                  </td>
                </tr>
              ))}
              {blog_posts.length === 0 && (
                <tr>
                  <td colSpan="4" className="p-4 text-center text-gray-500">No blog posts yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </UserLayout>
  )
}


